import { Endpiont } from 'shared/utils/Endpoints';
import { HTTP_CLIENT } from '../../utils/Interceptor';
import { useMutation, useQuery, useQueryClient } from 'react-query';
import { toastMessage } from 'shared/components/toast/Toast';
// ------------------ list PO-------
const getAllInventory = async (filter) => {
    const {
        data: { data }
    } = await HTTP_CLIENT.get(Endpiont.inventory.list + `${filter ? '?' + filter : ''}`);
    return data;
};
const GetAllInventoryQuery = (filter) => {
    return useQuery(['Inventorylist', filter], () => getAllInventory(filter));

};
// ------------------ Add INVENTORY-------
const addInventory = async (payload) => {
    return await HTTP_CLIENT.post(Endpiont.inventory.add, payload);
};
const AddInventoryMutation = () => {
    const queryClient = useQueryClient();
    return useMutation(addInventory, {
        onSuccess: (data) => {
            queryClient.invalidateQueries('Inventorylist');
            toastMessage('success', 'Inventory Added Successfully!');
        },
        onError: (error) => {
            const desc = error?.response?.data?.desc;
            if (desc) {
                toastMessage('error', desc || 'Server Error');
            }
        }
    });
};

// ------------------ INVENTORY PRODUCT-------

const inventoryProduct = async (payload) => {
    const {
        data: { data }
    } = await HTTP_CLIENT.post(Endpiont.inventory.inventoryProduct, payload);
    return data;
};
const InventoryProMutation = () => {
    const queryClient = useQueryClient();

    return useMutation(inventoryProduct, {
        onSuccess: (data) => {
            queryClient.invalidateQueries('InventoryProduct');
            // toastMessage('success', 'PO Added Successfully!');
        },
        onError: (error) => {
            const desc = error?.response?.data?.desc;
            if (desc) {
                toastMessage('error', desc || 'Server Error');
            }
        }
    });
};
// ------------------ INVENTORY PRODUCT UPDATE-------

const inventoryProductUpdate = async (payload) => {
    const {
        data: { data }
    } = await HTTP_CLIENT.patch(Endpiont.inventory.updateInventoryProduct, payload);
    return data;
};
const InventoryProUpdateMutation = () => {
    const queryClient = useQueryClient();

    return useMutation(inventoryProductUpdate, {
        onSuccess: (data) => {
            queryClient.invalidateQueries('InventoryProduct');
            queryClient.invalidateQueries('Inventorylist');
            toastMessage('success', 'Inventory Updated Successfully!');
        },
        onError: (error) => {
            const desc = error?.response?.data?.desc;
            if (desc) {
                toastMessage('error', desc || 'Server Error');
            }
        }
    });
};

// ------------------ GET SKU BY WAREHOUSE -------

const getSkuByWarehouse = async (warehouseId) => {
    if (!warehouseId) return [];
    const {
        data: { data }
    } = await HTTP_CLIENT.get(Endpiont.inventory.getSkuByWarehouse + `?warehouse=${warehouseId}`);
    return data;
};

const GetSkuByWarehouseQuery = (warehouseId) => {
    return useQuery(['SkuByWarehouse', warehouseId], () => getSkuByWarehouse(warehouseId), {
        enabled: !!warehouseId
    });
};

export { GetAllInventoryQuery, AddInventoryMutation, InventoryProMutation, InventoryProUpdateMutation, GetSkuByWarehouseQuery };
